import styled from 'styled-components'

/**
 * Single-line truncation for `WithEllipsisTooltip`, which applies no CSS
 * itself and only opens when its child's `scrollWidth` exceeds `offsetWidth`.
 *
 * The table uses auto layout, so `nowrap` text would otherwise widen its
 * cell; `contain: inline-size` keeps the cell at its column width. The inner
 * `inline-block` span truncates and keeps the tooltip centered on the text.
 */
export const EllipsisTextStyled = styled.span`
  display: block;
  contain: inline-size;

  > span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
  }
`
